module.exports = __webpack_public_path__ + "static/img/logo-dark.5792a8d5.svg";